import { refreshPage } from "./helpers/refreshPage";

export default async function handleBasketEvent(event) {
  if (event === "orderCreated") {
    window.location.href = InpostIziJavsscriptWoocommerce.thank_you_url;
    return Promise.resolve(true);
  }

  if (event === "basketProductChanged") {
    refreshPage();
    return Promise.resolve(true);
  }

  if (event === "basketDeleted") {
    return Promise.resolve(true);
  }
}
